import { SmallButtonConnect } from '../buttons/smallButtonConnect'
import { useTranslator } from '../translator/hook'
import './LinkageButton.css'
import { SmallButtonUpdate } from './smallButtonUpdate'
import { MinimizedReconnectManual } from '../modals/help/minimizedReconnectManual'
import { ConnectManualModal } from '../modals/help/connectManualModal'
import { useLinkage } from './useLinkage'
import { useConnectManualModal } from './useConnectManualModal'

interface LinkageButtonProps {
  onTriggerDownloadTutorial?: () => void
}

export const LinkageButton = ({
  onTriggerDownloadTutorial,
}: LinkageButtonProps = {}) => {
  const { t } = useTranslator()
  const { connected, hasCheckedStatus, isWide, code, label, hideCurrentChaff } =
    useLinkage()
  const { isOpen, open, close } = useConnectManualModal()

  return (
    <>
      <MinimizedReconnectManual
        connected={connected}
        hasCheckedStatus={hasCheckedStatus}
        onTriggerDownloadTutorial={onTriggerDownloadTutorial}
      />

      <div className="linkage-div">
        {isWide && <div className="linkage-content">{label}</div>}
        <SmallButtonConnect
          connected={connected}
          onClick={open}
          aria-disabled={!hasCheckedStatus}
          isWide={isWide}
          tooltipLabel={`${label}${connected ? t('linked') : t('link')}`}
        />
        <div onClick={(e) => e.stopPropagation()}>
          <SmallButtonUpdate
            connected={connected}
            isWide={isWide}
            tooltipLabel={t('update')}
            onReflect={hideCurrentChaff}
          />
        </div>
      </div>
      <ConnectManualModal isOpen={isOpen} onClose={close} code={code} />
    </>
  )
}
